// extracted by mini-css-extract-plugin
module.exports = {"main___clamped":"ReadMore_main___clamped__78cfu","main___isTooLongText":"ReadMore_main___isTooLongText__SSksl","button":"ReadMore_button__aW31W"};